import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhoneAlt, FaEnvelope, FaUser, FaChevronDown } from 'react-icons/fa';
import './TopBar.css';

const TopBar = ({ chatbotPage }) => (
  <div className={`topbar ${chatbotPage ? 'topbar--chatbot' : ''}`}>
    <div className="topbar-width topbar-inner">
      <div className="topbar-left">
        <a href="tel:+917021520017" className="topbar-item">
          <FaPhoneAlt /> <span>+91 70215 20017</span>
        </a>
        <span className="topbar-sep">|</span>
        <a href="mailto:info@databoltahi.com" className="topbar-item">
          <FaEnvelope /> <span>info@databoltahi.com</span>
        </a>
      </div>
      <div className="topbar-right">
        <Link to="/my-account" className="topbar-item">
          <FaUser /> <span>Client Login</span>
        </Link>
        <span className="topbar-sep">|</span>
        <Link to="/my-account" className="topbar-item">
          <span>My Account</span> <FaChevronDown className="topbar-chevron" />
        </Link>
      </div>
    </div>
  </div>
);

export default TopBar;